import { render } from "./page.vue?vue&type=template&id=022d8dcc&scoped=true"
import script from "./page.vue?vue&type=script&lang=js"
export * from "./page.vue?vue&type=script&lang=js"

import "./page.vue?vue&type=style&index=0&id=022d8dcc&lang=sass&scoped=true"

import exportComponent from "C:\\Users\\colin\\Documents\\WebProjects\\cee\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022d8dcc"]])

export default __exports__